import LectureTrackApi from '@/api/lectureTrack';
import { PROVIDER } from '@/components/LectureTrack/constant';
import { buildPowerBatchRedirectPath } from '@/components/LectureTrack/utils.function';

interface MasterclassLessonInfo {
  lessonCourseId?: string | null;
  lessonId?: string | null;
}

interface LessonDetailsResponse {
  data?: { lesson?: { data?: { provider?: string; url?: string } } };
}

/**
 * Returns the classroom path when the masterclass has a PowerBatch (Agora) lesson,
 * same as normal courses. Returns null otherwise or on any error, so callers can
 * continue with the existing Zoom / liveVideoLink flow.
 */
const getMasterclassPowerBatchPath = async ({
  lessonCourseId,
  lessonId,
}: MasterclassLessonInfo): Promise<string | null> => {
  if (!lessonCourseId || !lessonId) return null;
  try {
    const res = await LectureTrackApi.getLessonDetails<LessonDetailsResponse>({
      courseId: lessonCourseId,
      lessonId,
    });
    const lessonData = res?.data?.lesson?.data;
    if (lessonData?.provider?.toLowerCase() !== PROVIDER.POWERBATCH) return null;
    return buildPowerBatchRedirectPath(lessonData?.url);
  } catch {
    return null;
  }
};

export default getMasterclassPowerBatchPath;
